module.exports = __webpack_public_path__ + "static/media/img1.502afda5.png";